import { render, staticRenderFns } from "./OlMesurePlugin.vue?vue&type=template&id=3988e2e0&scoped=true"
import script from "./OlMesurePlugin.vue?vue&type=script&lang=ts"
export * from "./OlMesurePlugin.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./OlMesurePlugin.vue?vue&type=style&index=0&id=3988e2e0&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "3988e2e0",
  null
  ,true
)

export default component.exports